import { ErrorMessage, Field } from "formik";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormTimeField = ({
  label = "textField",
  labelClassName = "",
  name = "textField",
  value = "",
  onChange = () => {},
  className = "",
  placeholder = "",
  type = "time",
  required,
  ...props
}) => {
  return (
    <div className="w-full max-w-[20rem]">
      <Field name={name}>
        {({ field, meta }) => (
          <div className={`flex flex-col gap-1 ${className} w-full`}>
            {label && (
              <label
                htmlFor={name}
                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${labelClassName} ${
                  meta.touched && meta.error
                    ? "text-errorColor"
                    : labelClassName
                }`}
              >
                {formatUnderscoreToSpace(label)}
              </label>
            )}
            <input
              {...field}
              {...props}
              id={name}
              name={name}
              type={type}
              //   value={value}
              placeholder={placeholder}
              required={required}
              className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none ${
                          meta.touched && meta.error
                            ? "border-errorColor"
                            : "border-greyText"
                        }`}
            />
            <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
              <ErrorMessage name={name} />
            </label>
          </div>
        )}
      </Field>
    </div>
  );
};

export const FormDateField = ({
  label = "textField",
  labelClassName = "",
  name = "textField",
  value = "",
  onChange = () => {},
  className = "",
  placeholder = "",
  type = "date",
  required,
  ...props
}) => {
  return (
    <div className="w-full max-w-[20rem]">
      <Field name={name}>
        {({ field, meta }) => (
          <div className={`flex flex-col gap-1 ${className} w-full`}>
            {label && (
              <label
                htmlFor={name}
                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${labelClassName} ${
                  meta.touched && meta.error
                    ? "text-errorColor"
                    : labelClassName
                }`}
              >
                {label}
              </label>
            )}
            <input
              {...field}
              {...props}
              id={name}
              name={name}
              type={type}
              //   value={value}
              placeholder={placeholder}
              required={required}
              className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none ${
                          meta.touched && meta.error
                            ? "border-errorColor"
                            : "border-greyText"
                        }`}
            />
            <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
              <ErrorMessage name={name} />
            </label>
          </div>
        )}
      </Field>
    </div>
  );
};
